<!-- This needs to be outside ng-container or @ViewChild will throw an error -->
<ng-template measurementAddHost></ng-template>

<ng-container
  *ngTemplateOutlet="{ loading: loadingTemplate, error: errorTemplate }[state]"
></ng-container>

<ng-template #errorTemplate>
  <div class="gp-alert gp-alert-danger p3-regular mb-4">
    <span class="p3-semibold">{{ 'ERROR' | translate }}</span>
    {{ 'FAILURE.GENERAL_ERROR.CONTENT' | translate }}
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <gpu-loading-spinner-wrapper>
    <gpu-loading-spinner></gpu-loading-spinner>
  </gpu-loading-spinner-wrapper>
</ng-template>
